import { ar } from "@src/i18n"

const WEIGHT_UPC_PREFIX = "20"
const WEIGHT_CORE_LENGTH = 5

export function saveWeightUpc(value?: string | null, isWeightProduct?: boolean): string | undefined {
  if (value == null) return undefined
  const digits = String(value).replace(/\D/g, "")
  if (!isWeightProduct) return digits || undefined

  const core = digits.length > WEIGHT_CORE_LENGTH ? digits.slice(-WEIGHT_CORE_LENGTH) : digits.padStart(WEIGHT_CORE_LENGTH, "0")
  return `${WEIGHT_UPC_PREFIX}${core}`
}
export function formatWeightUpc(upc?: string | null, isWeightProduct?: boolean): string | undefined {
  if (!upc) return undefined
  const s = String(upc)
  if (!isWeightProduct) return s
  const core = s.startsWith(WEIGHT_UPC_PREFIX) ? s.slice(WEIGHT_UPC_PREFIX.length) : s
  const digits = core.replace(/\D/g, "")
  const stripped = digits.replace(/^0+/, "")
  return stripped === "" ? "0" : stripped
}

export function formatQty(qty: number, type?: string | null): string {
  if (type === "WEIGHT_PRODUCT") return `${(qty / 1000).toFixed(2)} ${ar.kg}`
  return qty.toString()
}

export function getPaymentLabel(method: string): string {
  if (method === "card") return ar.visa
  const label = ar[method as keyof typeof ar]
  return typeof label === "string" ? label : method
}
